import type { Editor } from 'tinymce';

type BlobInfo = {
  blob: () => Blob;
  filename: () => string;
};

export const uploadImageAsDataUrl = (blobInfo: BlobInfo): Promise<string> => (
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result);
        return;
      }
      reject(new Error('Failed to read image'));
    };
    reader.onerror = () => reject(new Error('Failed to read image'));
    reader.readAsDataURL(blobInfo.blob());
  })
);

export const createImageFilePickerCallback = (
  getEditor: () => Editor | null | undefined,
) => (callback: (url: string, meta: { title: string }) => void) => {
  const input = document.createElement('input');
  input.setAttribute('type', 'file');
  input.setAttribute('accept', 'image/*');

  input.addEventListener('change', (event: Event) => {
    const target = event.target as HTMLInputElement;
    const file = target.files?.[0];
    if (!file) {
      return;
    }

    const reader = new FileReader();
    reader.addEventListener('load', () => {
      const result = reader.result as string;
      const base64 = result.split(',')[1];
      const blobCache = getEditor()?.editorUpload?.blobCache;

      if (blobCache && base64) {
        const id = `blobid${Date.now()}`;
        const blobInfo = blobCache.create(id, file, base64);
        blobCache.add(blobInfo);
        callback(blobInfo.blobUri(), { title: file.name });
        return;
      }

      callback(result, { title: file.name });
    });
    reader.readAsDataURL(file);
  });

  input.click();
};

export const emailEditorImageConfig = {
  paste_data_images: true,
  automatic_uploads: true,
  images_file_types: 'jpeg,jpg,png,gif,webp',
  images_upload_handler: uploadImageAsDataUrl,
  file_picker_types: 'image',
};
